/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState, useEffect } from 'react';
import { Form, InputGroup, Row, Image, Col, Card } from 'react-bootstrap';
import { AiFillCloseCircle } from 'react-icons/ai';
import { useDropzone } from 'react-dropzone';

import * as S from '../../styles';
import * as LS from './styles';

export interface IFileDropZoneProps {
    id: string;
    fontScale?: number;

    label?: string;
    labelColor?: string;
    errorText?: string;
    value?: any;
    required?: boolean;
    placeholder?: string;
    supportedFormat?: string[];
    onCompChange?(id: string, payload: any): void;
    maxFiles: number;
    maxSize?: number;
    defaultDocImage?: string;
    hasError?: boolean;
    readOnly?: boolean;
}

export const FileDropZone = ({
    id,
    fontScale,

    label,
    labelColor,
    errorText,
    value,
    required,
    placeholder,
    onCompChange,
    supportedFormat,
    maxFiles,
    maxSize,
    defaultDocImage,
    hasError,
    readOnly,
}: IFileDropZoneProps) => {
    const [files, setFiles] = useState(value ?? []);
    useEffect(() => setFiles(value ?? []), [value]);

    const [validSize, setValidSize] = useState(true);
    const [fileSupported, setFileSupported] = useState(true);
    const [isInvalid, setIsInvalid] = useState(false);
    const errorMsg = [];
    Array.isArray(supportedFormat) &&
        supportedFormat.forEach((element) => {
            errorMsg.push(element.split('/')[1]);
        });

    useEffect(() => {
        onCompChange && onCompChange(id, value);
    }, [value]);
    console.log('ki->', isInvalid, hasError, '.', errorText);

    useEffect(() => {
        if (hasError) {
            setIsInvalid(hasError);
        }
    }, [hasError]);

    const { getRootProps, getInputProps } = useDropzone({
        maxFiles: maxFiles,
        // maxSize: maxSize,
        // @ts-ignore
        multiple: maxFiles > 1,
        onDrop: (files) => {
            const allFiles: any = [];
            for (let i = 0; i < files.length; i++) {
                let file = files[i];

                console.log(`fileType::`, file);
                if (file.size > maxSize) {
                    setValidSize(false);
                }
                if (file.size < maxSize) {
                    if (!validSize) {
                        setValidSize(true);
                    }
                }
                if (
                    Array.isArray(supportedFormat) &&
                    !supportedFormat?.includes(file?.type)
                ) {
                    setFileSupported(false);
                }
                if (file?.name?.endsWith('.jfif')) {
                    setFileSupported(false);
                }
                if (
                    Array.isArray(supportedFormat) &&
                    supportedFormat?.includes(file?.type)
                ) {
                    if (!fileSupported) {
                        setFileSupported(true);
                    }
                }
                // Make new FileReader
                let reader = new FileReader();

                // Convert the file to base64 text
                reader.readAsDataURL(file);

                reader.onload = () => {
                    // Make a fileInfo Object
                    let fileInfo = {
                        name: file.name,
                        type: file.type,
                        size: Math.round(file.size / 1000) + ' kB',
                        base64: reader.result,
                        file: file,
                    };

                    // Push it to the state
                    if (file.size < maxSize) allFiles.push(fileInfo);

                    // If all files have been proceed
                    if (allFiles.length == files.length) {
                        if (
                            Array.isArray(supportedFormat) &&
                            supportedFormat?.includes(file?.type)
                        ) {
                            onCompChange && onCompChange(id, allFiles);
                            setFiles(allFiles);
                        }
                    }
                }; // reader.onload
            } // for
        },
    });

    const removeSelection = (index: number) => {
        if (index > -1) {
            const _files = files?.map((item, key) => {
                if (key === index) {
                    return { ...item, operation: 'REMOVE' };
                }
                return item;
            });
            // if (_files[index] !== undefined) {
            //     _files.splice(index, 1);
            // }
            setFiles(_files);
            onCompChange && onCompChange(id, _files);
        }
    };

    const DropzoneFile = (props: any) => {
        const { name, base64, fileIndex } = props;
        const imageSrc = props?.type?.includes('image')
            ? base64
            : defaultDocImage;

        console.log('imageis:', imageSrc);

        return (
            <>
                <Col xs={6} className="dropzone-preview mt-2">
                    <div style={LS.DropZoneFileContainer}>
                        <Image
                            src={imageSrc}
                            className="dropzone-image"
                            resizeMode={'contain'}
                            thumbnail
                            width={'100px'}
                            height={'100px'}
                        />
                        {!readOnly && (
                            <AiFillCloseCircle
                                size={22}
                                onClick={removeSelection.bind(null, fileIndex)}
                                style={LS.DropZoneFileRemoveIcon}
                            />
                        )}
                    </div>
                    <Card.Text className="dropzone-filename">{name}</Card.Text>
                </Col>
            </>
        );
    };

    const _renderLabelIf = () => {
        if (label) {
            return (
                <S.FormLabel fontScale={fontScale} color={labelColor}>
                    {label}
                    {required && <sup style={{ color: 'red' }}>*</sup>}
                </S.FormLabel>
            );
        }
        return null;
    };

    const _renderErrorTextIf = () => {
        if (hasError && errorText) {
            return (
                <S.FeedbackOtherLabel type="tooltip" fontScale={fontScale}>
                    {errorText}
                </S.FeedbackOtherLabel>
            );
        }
        return null;
    };

    const _renderFiles = () => {
        return (
            <Row className="dropzone-files ms-2">
                {!validSize ? (
                    <span style={{ color: 'red' }}>
                        {`File size is too big. Maximum allowed is ${Math.round(
                            maxSize / 1000000
                        )} MB`}
                    </span>
                ) : !fileSupported ? (
                    <span style={{ color: 'red' }}>
                        {`File Type not supported, please upload file type with one of ${errorMsg}(jfif is not allowed).`}
                    </span>
                ) : (
                    files
                        ?.filter((item) => !item?.operation)
                        ?.map((file: any, index: number) => (
                            // console.log("imageis",...file),
                            <DropzoneFile
                                key={file.name}
                                base64={file.base64 ?? file.src}
                                // base64={file.src}
                                {...file}
                                fileIndex={index}
                            />
                        ))
                )}
            </Row>
        );
    };

    const addOnToolTip = supportedFormat?.includes('application/pdf')
        ? 'Upload file type with one of png,pdf,jpeg,jpg (jfif is not allowed).'
        : 'Upload file type with one of png,jpeg,jpg (jfif is not allowed).';

    const tooltip =
        maxFiles === 1
            ? `${maxFiles} file is the maximum number of files you can drop here`
            : `${maxFiles} files are the maximum number of files you can drop here`;
    return (
        <>
            <Form.Group
                id={id}
                className="formgroup"
                style={{ minHeight: '5rem', fontSize: '16pt' }}
            >
                {_renderLabelIf()}
                {!readOnly ? (
                    <InputGroup
                        {...getRootProps({
                            className:
                                'dropzone rounded d-flex align-items-center justify-content-center mb-4',
                        })}
                    >
                        <S.FormControl
                            fontScale={fontScale}
                            className="formcontrol shadow-none"
                            {...getInputProps()}
                        />
                        <div className="dz-default dz-message text-center">
                            <p
                                className="dz-button mb-0"
                                style={{
                                    fontSize:
                                        fontScale !== undefined
                                            ? `${16 + fontScale * 1.5}px`
                                            : '16px',
                                }}
                            >
                                Drop files here to upload
                            </p>
                            <em
                                style={{
                                    paddingLeft: '2px',
                                    paddingRight: '2px',
                                    fontSize:
                                        fontScale !== undefined
                                            ? `${16 + fontScale * 1.5}px`
                                            : '16px',
                                }}
                            >
                                ({tooltip})
                            </em>
                            <br />
                            <em
                                style={{
                                    fontSize:
                                        fontScale !== undefined
                                            ? `${16 + fontScale * 1.5}px`
                                            : '16px',
                                    paddingLeft: '2px',
                                    paddingRight: '2px',
                                }}
                            >
                                ({addOnToolTip})
                            </em>
                        </div>
                        <InputGroup>{_renderErrorTextIf()}</InputGroup>
                    </InputGroup>
                ) : (
                    _renderFiles()
                )}
            </Form.Group>
            {!readOnly && _renderFiles()}
        </>
    );
};

FileDropZone.defaultProps = {
    required: false,
    maxFiles: 5,
    maxSize: 5000000,
    hasError: false,
    defaultDocImage:
        'https://s3.ap-south-1.amazonaws.com/io.vlinder.icons/certificate_grey.png',
};
